// GTM: position for promoted brand (casino of the month) blocks.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.probrand-card__btn--stretched').forEach((element, index) => {
    if (element) element.dataset.position = index + 1;
  });

  document.querySelectorAll('.probrand-card__btn').forEach((element, index) => {
    if (element) element.dataset.position = index + 1;
  });
});